<template>
	<resources-index :resources="resources" type="podcast" plural="podcasts"></resources-index>
</template>

<script>

import ResourcesIndex from '@/views/resources/Index'
import {sync} from "vuex-pathify";
export default {
	name: "PodcastsIndex",
	components: {
		ResourcesIndex
	},
	computed: {
		resources: sync('podcasts/podcasts'),
	},
}
</script>